export default {
	REGULAR_TAB: '0',
	STANDARDS_TAB: '1',
}
